import React from 'react';

import {render} from 'react-dom';
import {Provider} from 'react-redux';

import {RootRouter} from 'app/containers/general/RootRouter';
import store from 'app/store/AppStore';
import {loadSafariAutocompleteFix} from 'app/utils/safari-autocomplete';

// fix safari autofill/react bug
loadSafariAutocompleteFix();
// never show scrollbar for body, we have scrollable divs
document.body.style.overflow = 'hidden';

render(
  <Provider store={store}>
    <RootRouter />
  </Provider>,
  document.getElementById('app-placeholder')
);
